import { render, staticRenderFns } from "./box18.vue?vue&type=template&id=9fbcd84c&scoped=true&"
import script from "./box18.vue?vue&type=script&lang=js&"
export * from "./box18.vue?vue&type=script&lang=js&"
import style0 from "./box18.vue?vue&type=style&index=0&id=9fbcd84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbcd84c",
  null
  
)

export default component.exports